import { Link } from 'react-router-dom';
import { catalog } from '@/mocks/catalog';

const entries = [
  {
    to: '/category/movie',
    icon: 'ri-film-line',
    title: '电影频道',
    desc: '院线新片与经典佳作',
    count: catalog.filter((i) => i.type === 'movie').length,
    role: 'primary',
  },
  {
    to: '/category/tv',
    icon: 'ri-tv-2-line',
    title: '电视剧频道',
    desc: '热播剧集与口碑长剧',
    count: catalog.filter((i) => i.type === 'tv').length,
    role: 'secondary',
  },
  {
    to: '/news',
    icon: 'ri-newspaper-line',
    title: '专题资讯',
    desc: '观影指南与行业观察',
    count: 8,
    role: 'accent',
  },
];

const bubbleClass: Record<string, string> = {
  primary: 'bg-primary-500 text-background-50',
  secondary: 'bg-secondary-500 text-background-50',
  accent: 'bg-accent-500 text-foreground-950',
};

export default function CategoryQuickLinks() {
  return (
    <section aria-label="分类快捷入口" className="mt-8 md:mt-10">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group flex items-center gap-4 p-5 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 hover:bg-background-50 transition-colors"
          >
            <span className={`w-14 h-14 rounded-lg flex items-center justify-center shrink-0 ${bubbleClass[entry.role]}`}>
              <i className={`${entry.icon} text-2xl`}></i>
            </span>
            <span className="min-w-0">
              <span className="flex items-center gap-2">
                <span className="font-heading font-bold text-base text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {entry.title}
                </span>
                <i className="ri-arrow-right-up-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
              </span>
              <span className="block mt-1 text-sm text-foreground-500 truncate">{entry.desc}</span>
              <span className="block mt-1 text-xs text-foreground-400">{entry.count} 部内容</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}